import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import subscription from './subscription'
/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
export const show = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/admin/creators/{creatorProfile}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
show.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return show.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
show.get = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
show.head = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
const showForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
showForm.get = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::show
* @see app/Http/Controllers/Admin/CreatorController.php:101
* @route '/app/admin/creators/{creatorProfile}'
*/
showForm.head = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\CreatorController::commission
* @see app/Http/Controllers/Admin/CreatorController.php:329
* @route '/app/admin/creators/{creatorProfile}/commission'
*/
export const commission = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: commission.url(args, options),
    method: 'put',
})

commission.definition = {
    methods: ["put"],
    url: '/app/admin/creators/{creatorProfile}/commission',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::commission
* @see app/Http/Controllers/Admin/CreatorController.php:329
* @route '/app/admin/creators/{creatorProfile}/commission'
*/
commission.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return commission.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::commission
* @see app/Http/Controllers/Admin/CreatorController.php:329
* @route '/app/admin/creators/{creatorProfile}/commission'
*/
commission.put = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: commission.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::commission
* @see app/Http/Controllers/Admin/CreatorController.php:329
* @route '/app/admin/creators/{creatorProfile}/commission'
*/
const commissionForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: commission.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::commission
* @see app/Http/Controllers/Admin/CreatorController.php:329
* @route '/app/admin/creators/{creatorProfile}/commission'
*/
commissionForm.put = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: commission.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

commission.form = commissionForm

/**
* @see \App\Http\Controllers\Admin\CreatorController::block
* @see app/Http/Controllers/Admin/CreatorController.php:272
* @route '/app/admin/creators/{creatorProfile}/block'
*/
export const block = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: block.url(args, options),
    method: 'put',
})

block.definition = {
    methods: ["put"],
    url: '/app/admin/creators/{creatorProfile}/block',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::block
* @see app/Http/Controllers/Admin/CreatorController.php:272
* @route '/app/admin/creators/{creatorProfile}/block'
*/
block.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return block.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::block
* @see app/Http/Controllers/Admin/CreatorController.php:272
* @route '/app/admin/creators/{creatorProfile}/block'
*/
block.put = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: block.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::block
* @see app/Http/Controllers/Admin/CreatorController.php:272
* @route '/app/admin/creators/{creatorProfile}/block'
*/
const blockForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: block.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::block
* @see app/Http/Controllers/Admin/CreatorController.php:272
* @route '/app/admin/creators/{creatorProfile}/block'
*/
blockForm.put = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: block.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

block.form = blockForm

/**
* @see \App\Http\Controllers\Admin\CreatorController::refreshSettlement
* @see app/Http/Controllers/Admin/CreatorController.php:346
* @route '/app/admin/creators/{creatorProfile}/refresh-settlement'
*/
export const refreshSettlement = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshSettlement.url(args, options),
    method: 'post',
})

refreshSettlement.definition = {
    methods: ["post"],
    url: '/app/admin/creators/{creatorProfile}/refresh-settlement',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::refreshSettlement
* @see app/Http/Controllers/Admin/CreatorController.php:346
* @route '/app/admin/creators/{creatorProfile}/refresh-settlement'
*/
refreshSettlement.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return refreshSettlement.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::refreshSettlement
* @see app/Http/Controllers/Admin/CreatorController.php:346
* @route '/app/admin/creators/{creatorProfile}/refresh-settlement'
*/
refreshSettlement.post = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshSettlement.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::refreshSettlement
* @see app/Http/Controllers/Admin/CreatorController.php:346
* @route '/app/admin/creators/{creatorProfile}/refresh-settlement'
*/
const refreshSettlementForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshSettlement.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::refreshSettlement
* @see app/Http/Controllers/Admin/CreatorController.php:346
* @route '/app/admin/creators/{creatorProfile}/refresh-settlement'
*/
refreshSettlementForm.post = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshSettlement.url(args, options),
    method: 'post',
})

refreshSettlement.form = refreshSettlementForm

const creators = {
    show: Object.assign(show, show),
    commission: Object.assign(commission, commission),
    block: Object.assign(block, block),
    refreshSettlement: Object.assign(refreshSettlement, refreshSettlement),
    subscription: Object.assign(subscription, subscription),
}

export default creators